// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `tr th {
  background-color: var(--primaryUltraLightColor);
  border: none;
}

th.p-sortable-column.p-highlight {
  background-color: #e0f6dd;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
